import DataApi from "./DataApi";

export default class PicklistApi {
  constructor() {
    this.dataApi = new DataApi("picklist");
  }

  // Get all picklist values for a field (including inactive ones)
  getPicklistValues(fieldId) {
    return this.dataApi.get(`/field/${fieldId}`);
  }

  // Get only active picklist values for a field (for display in forms)
  getActivePicklistValues(fieldId) {
    return this.dataApi.get(`/field/${fieldId}/active`);
  }

  // Add a new picklist value
  addPicklistValue(valueData) {
    return this.dataApi.create(valueData);
  }

  // Update a picklist value
  updatePicklistValue(valueId, updateData) {
    return this.dataApi.update(updateData, valueId);
  }

  // Delete a picklist value (permanent deletion)
  deletePicklistValue(valueId) {
    return this.dataApi.delete(valueId);
  }

  // Deactivate a picklist value (with optional replacement)
  deactivatePicklistValue(valueId, replacementValueKey = null) {
    return this.dataApi.put(`/${valueId}/deactivate`, {
      replacementValueKey
    });
  }

  // Reactivate a picklist value
  reactivatePicklistValue(valueId) {
    return this.dataApi.put(`/${valueId}/reactivate`, {});
  }

  // Bulk update picklist values (for reordering, etc.)
  bulkUpdatePicklistValues(fieldId, values) {
    return this.dataApi.put(`/field/${fieldId}/bulk`, {
      values
    });
  }

  // Get usage count for a picklist value
  getPicklistValueUsage(valueId, objectName, fieldName) {
    const url = objectName && fieldName
      ? `/usage?objectName=${objectName}&fieldName=${fieldName}`
      : `/usage`;
    return this.dataApi.get(`/${valueId}${url}`);
  }

  // Replace picklist values in existing records
  replacePicklistValues(fieldId, objectName, fieldName, oldValue, newValue) {
    return this.dataApi.post(`/${fieldId}/replace-values`, {
      objectName,
      fieldName,
      oldValue,
      newValue
    });
  }

  // Migrate existing JSON picklist values to the new table structure
  migratePicklistValues(fieldId, picklistValuesJson) {
    return this.dataApi.post(`/${fieldId}/migrate`, {
      picklistValues: picklistValuesJson
    });
  }
}
